<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-toolbar color="primary" dense dark>
        <v-toolbar-title>Bảng quy đổi kích cỡ</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- <v-card-text>
        <v-row class="mx-1 mt-4">
          <div class="image-input" :style="{ 'background-image': imageStyle }" @click="chooseImage">
            <div v-if="imageUrl && !rawImageRemoved" class="placeholder">
              <v-img :src="imageUrl" alt="Bảng quy đổi" contain />
            </div>
            <span v-else-if="!imagePreview" class="placeholder">Tải ảnh bảng quy đổi</span>
            <input class="file-input" ref="fileInput" type="file" accept="image/*" @change="onChange" />
          </div>
          <v-btn icon v-if="imagePreview || imageUrl">
            <v-icon @click="removeImage" color="grey">mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-text> -->
      <v-card-text>
        <v-row class="mx-1 mt-4">
          <v-col cols="12">
            <div class="pdf-preview-wrapper">
              <iframe
                :src="pdfUrl"
                type="application/pdf"
                width="100%"
                height="400px"
                style="border: 1px solid #ccc; border-radius: 6px"
              ></iframe>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">Huỷ</v-btn>
        <!-- <v-spacer />
        <v-btn color="primary" @click="save">Lưu</v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    state: Boolean,
  },
  data() {
    return {
      dialog: false,
      imagePreview: null,
      selectedImage: null,
      rawImageRemoved: false,
    }
  },
  computed: {
    ...mapState('UniformOrdersRegister', ['uniformConfig']),
    imageUrl() {
      return this.uniformConfig && this.uniformConfig.image ? this.uniformConfig.image.url : ''
    },
    imageStyle() {
      if (this.imagePreview) return `url(${this.imagePreview})`
      if (this.imageUrl && !this.rawImageRemoved) return `url(${this.imageUrl})`
      return 'none'
    },
    pdfUrl() {
      return '/size_uniform_chart_2024.pdf'
    },
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.imagePreview = null
        this.selectedImage = null
        this.rawImageRemoved = false
      }
    },
  },
  methods: {
    ...mapActions('UniformOrdersRegister', ['uploadImage', 'destroyImage']),
    chooseImage() {
      this.$refs.fileInput.click()
    },
    onChange(event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = e => {
          this.imagePreview = e.target.result
        }
        reader.readAsDataURL(file)
        this.selectedImage = file
        this.rawImageRemoved = false
      }
    },
    removeImage() {
      this.imagePreview = null
      this.selectedImage = null
      this.rawImageRemoved = true
    },
    async save() {
      this.$loading.active = true
      try {
        if (this.uniformConfig.image) {
          const currentImageId = this.uniformConfig.image.id

          if (this.rawImageRemoved && currentImageId) {
            await this.destroyImage(currentImageId)
          }
        }

        if (this.selectedImage) {
          const formData = new FormData()
          formData.append('files', this.selectedImage)
          formData.append('refId', this.uniformConfig.id)
          formData.append('ref', 'uniform-config')
          formData.append('field', 'image')
          await this.uploadImage(formData)
        }

        this.$alert.updateSuccess()
        this.cancel()
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
      this.$emit('update:state', false)
    },
  },
}
</script>

<style scoped>
.image-input {
  width: 100%;
  height: 240px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  border: 2px dashed #ccc;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
}
.placeholder {
  background: #f9f9f9;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 16px;
  font-family: sans-serif;
}
.file-input {
  display: none;
}
.pdf-preview-wrapper {
  background-color: #f9f9f9;
  padding: 8px;
  border-radius: 6px;
}
</style>
